import { render, staticRenderFns } from "./News3.vue?vue&type=template&id=58a36705&scoped=true"
import script from "./News3.vue?vue&type=script&lang=js"
export * from "./News3.vue?vue&type=script&lang=js"
import style0 from "./News3.vue?vue&type=style&index=0&id=58a36705&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a36705",
  null
  
)

export default component.exports